  document.addEventListener("DOMContentLoaded", function() {
    console.log("JS personalizzato attivo!");


    /* */
      const DEBUG_LEVEL = 1;
    
      function debug(level, ...args) {
        if (DEBUG_LEVEL >= level) console.log(...args);
      }
    
      function applyCollectionFilterLogic() {
        debug(1, "[DEBUG] Avvio logica filtro");


        /* new model*/

            // Estrae il nome della collezione dal link canonical
            const canonicalLink = document.querySelector('link[rel="canonical"]');
            let collectionSlug = 'all'; // fallback
            if (canonicalLink) {
              const href = canonicalLink.getAttribute('href');
              const match = href.match(/\/collections\/([^\/?#]+)/);
              if (match && match[1]) {
                collectionSlug = match[1];
              }
            }

           const safeCollectionSlug = collectionSlug.replace(/-/g, '_').charAt(0);
           const paramName = `${safeCollectionSlug}`;
       //   console.log("paramName--------------"+paramName);
       //    console.log("safeCollectionSlug--------------"+safeCollectionSlug);
       //    console.log("--------------filter.p.m.custom.car_model_"+safeCollectionSlug);

        /* new model*/
    
        const urlParams = new URLSearchParams(window.location.search);
       // const filtroAttivo = urlParams.get("filter.p.m.custom.car_model");
        const filtroAttivo = urlParams.get("filter.p.m.custom.car_model_"+safeCollectionSlug);
     //   console.log("filtroAttivo > --------------"+filtroAttivo);
        debug(1, "[DEBUG] Filtro attivo da URL:", filtroAttivo); //return false;
    
        if (filtroAttivo) {
          const filtroNormalizzato = decodeURIComponent(filtroAttivo).toLowerCase().trim();
          debug(2, "[DEBUG] Filtro normalizzato:", filtroNormalizzato);
    
          document.querySelectorAll('.js-collection-click').forEach(function (el) {
            const label = el.getAttribute('aria-label');
            const labelNormalizzato = label ? label.trim().toLowerCase() : "";
    
            debug(2, "[DEBUG] Controllo blocco:", labelNormalizzato);
   // console.log("-------"+labelNormalizzato+"="+filtroNormalizzato);
            if (labelNormalizzato === filtroNormalizzato) {
              debug(1, "[DEBUG] MATCH trovato! Applico classe is-selected a:", label);
              el.classList.add('is-selected');
            }
          });
        } else {
          debug(1, "[DEBUG] Nessun filtro attivo. Clicco sul primo blocco.");
          const primoItem = document.querySelector('.js-collection-click');
          if (primoItem) {
            debug(1, "[DEBUG] Clicco su:", primoItem.getAttribute('aria-label'));
            primoItem.click();
          }
        }
      }
    
      // Usa MutationObserver per attendere che i blocchi vengano caricati
      const observer = new MutationObserver(function (mutations, obs) {
        const found = document.querySelector('.js-collection-click');
        if (found) {
          debug(1, "[DEBUG] Elemento .js-collection-click trovato nel DOM, eseguo logica");
          applyCollectionFilterLogic();
          obs.disconnect(); // ferma l'osservazione dopo il primo match
        }
      });
    
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    
      debug(1, "[DEBUG] Observer inizializzato");
    /* */

  /* CLICK MODELS */
document.querySelectorAll(".js-collection-click").forEach(function (el) {
  console.log("A1");
  el.addEventListener("click", function () {
    console.log("A12");
    const label = el.getAttribute("aria-label");
    if (!label) return;
    console.log("A3");
    // Normalizza label → es. "TT (2015>) MK3"
    const normalizedLabel = label.trim();

    // Codifica per URL → "TT+%282015%3E%29+MK3"
    const encodedLabel = encodeURIComponent(normalizedLabel).replace(/%20/g, '+');

    // Ricava la collezione corrente dall'URL (es. "/collections/audi")
    const path = window.location.pathname;

      
  //  const collectionMatch = path.match(/^\/collections\/[^\/]+/);
    const collectionMatch = path.match(/^\/(?:[a-z]{2}\/)?collections\/[^\/]+/);




    //new model
      const canonicalLink = document.querySelector('link[rel="canonical"]');
      let collectionSlug = 'all'; // fallback
      if (canonicalLink) {
        const href = canonicalLink.getAttribute('href');
        const match = href.match(/\/collections\/([^\/?#]+)/);
        if (match && match[1]) {
          collectionSlug = match[1];
        }

      //  console.log("------------------->"+match[1]);
      //  console.log("------------------->"+match[2]);

      }
  

  
      // Costruisce il nome dinamico del filtro con trattino basso
      const safeCollectionSlug = collectionSlug.replace(/-/g, '_').charAt(0);
      const paramName = `filter.p.m.custom.car_model_${safeCollectionSlug}`;    
      console.log("collectionSlug => "+collectionSlug); 
    console.log("paramName => "+paramName); 
   // return false;
    //new model
    
   // const collectionPath = collectionMatch ? collectionMatch[0] : '/collections/all';

    // Recupera prefisso locale dal path corrente: /it-it/... o /en-it/...
  const localePrefix = (() => {
    const segs = window.location.pathname.split('/').filter(Boolean);
    return segs.length > 0 && /^[a-z]{2}-[a-z]{2}$/i.test(segs[0])
      ? '/' + segs[0]
      : '/it-it'; // fallback se non c'è prefisso
  })();

    const collectionPath = collectionMatch ? collectionMatch[0] : localePrefix + '/collections/'+collectionSlug;
    
    console.log("A4");
    // Crea nuovo URL con solo il filtro attivo
    const finalUrl = `${collectionPath}?filter.p.m.custom.car_model=${encodedLabel}`;
    console.log("Navigo verso:", finalUrl);


    // Costruisce il nome dinamico del filtro con trattino basso
    //const paramName = `filter.p.m.custom.car_model_${collectionSlug.replace(/-/g, '_')}`;
    const finalUrl2 = `${collectionPath}?${paramName}=${encodedLabel}`;
    console.log("Navigo verso:", finalUrl2);
   //return false;

    window.location.href = finalUrl2;
   // window.location.href = finalUrl;
  });
});


  /* CLICK MODELS */

    
    console.log("=== INIZIO DEBUG FILTRO MARCA v2 ===");

    (function () {
      const pathParts = window.location.pathname.split('/');
      const collection = pathParts.includes("collections") ? pathParts[pathParts.indexOf("collections") + 1] : null;
    
 //     console.log("[DEBUG] URL corrente:", window.location.pathname);
 //     console.log("[DEBUG] Collection rilevata:", collection);
    
      if (!collection) {
        //console.warn("[DEBUG] Nessuna collection trovata nella URL.");
        return;
      }
    
      const collectionName = collection.toUpperCase();
      //console.log("[DEBUG] Nome normalizzato:", collectionName);
    
      const filterItems = document.querySelectorAll('.filter-item .item');
      //console.log("[DEBUG] Trovati", filterItems.length, "blocchi filtro");
    
      filterItems.forEach((item, index) => {
        const link = item.querySelector('.bls__link-filter');
        if (!link) return;
    
        const text = link.textContent.trim().toUpperCase().replace(/\s*\(.*?\)\s*/g, '');
        //console.log(`\n[DEBUG] [${index + 1}] Testo filtro trovato:`, text);
    
        if (text === collectionName) {
          //console.log(`[DEBUG] ✅ MATCH con collection! Applico classi a LI e checkbox`);
    
          // Aggiungi classe active o current-filter
          item.classList.add('current-filter');
    
          // Pulisci href (comportamento Shopify)
          link.href = `/collections/${collection}`;
          //console.log(`[DEBUG] → Nuovo href semplificato: ${link.href}`);
    
          // Marca il checkbox
          const checkbox = link.querySelector('.checkbox');
          if (checkbox) {
            checkbox.classList.add('checked');
            //console.log("[DEBUG] → Checkbox marcato come .checked");
          }
        } else {
         //console.log("[DEBUG] ✖ Nessuna corrispondenza con la collection");
        }
      });
    
      //console.log("=== FINE DEBUG FILTRO MARCA v2 ===");
    })();

  });


